import { Building2, FolderKanban } from '@/components/icons';
import type { Project } from '@/lib/types';
import { Select } from '@/components/ui';

/** "Whole organization" or one project (pair with useScope). */
export function ScopePicker({
  projects,
  projectId,
  onChange,
  label = 'Applies to',
}: {
  projects: Project[];
  projectId: string | null;
  onChange: (projectId: string | null) => void;
  label?: string;
}) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 dark:text-slate-300">
        {projectId ? <FolderKanban className="size-4" /> : <Building2 className="size-4" />}
        {label}
      </span>
      <Select
        aria-label={label}
        wrapperClassName="w-72"
        value={projectId ?? ''}
        onChange={(e) => onChange(e.target.value || null)}
        options={[
          { value: '', label: 'Whole organization' },
          ...projects.map((p) => ({ value: p.id, label: `Project: ${p.name}` })),
        ]}
      />
    </div>
  );
}
